import io from "socket.io-client"

export default class WebsocketConnection {
  #namespace;
  #isAuth = false;

  constructor(namespace) {
    this.#namespace = namespace;
  }

  connect(onSuccess, onAuthFailed, onDisconnect) {
    const url = process.env.VUE_APP_WEBSOCKET_URL;
    const socket = io(url + '/' + this.#namespace);
    socket.on('auth', (data) => {
      if (data.success) {
        this.#isAuth = true;
        if (onSuccess) {
          onSuccess(socket);
        }
      } else {
        console.log("Failed to authenticate on websocket server: " + data.error);
        if (onAuthFailed) {
          onAuthFailed();
        }
      }
    });
    socket.on('disconnect', () => {
      if (this.#isAuth && onDisconnect) {
        //TODO: show message to reload page
        onDisconnect();
      }
    });

    return socket;
  }
}